import { DelegatedObservableArrayChangeListenner, ObservableArray, ObservableArrayChangeListenner } from "binder";

export class ListSyncronizer<T,TU>{
    private _mapping:Map<T,TU>;
    private _delegatedChangeListenner : ObservableArrayChangeListenner;
    private _source:ObservableArray<T>;
    private _destination:ObservableArray<TU>;
    private _creator:(x:T)=>TU;
    constructor() {
        this._mapping = new Map<T,TU>();
    }
    public synronize(source:ObservableArray<T>,destination:ObservableArray<TU>,creator:(x:T)=>TU){
        this._source = source;
        this._destination = destination;
        this._creator = creator;
        this._delegatedChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.update());
        source.addChangeListenner(this._delegatedChangeListenner);
        this.update();
    }
    private update(){
        let temp = this._source.map(x=>{
            if(this._mapping.has(x)){
                return this._mapping.get(x)
            }else{
                let newDestinationItem = this._creator(x);
                this._mapping.set(x,newDestinationItem);
                return newDestinationItem;
            }
        });
        let toRemoveFromMap = [];
        this._mapping.forEach((value,key)=>{
            if(this._source.indexOf(key)==-1){
                toRemoveFromMap.push(key);
            }
        });
        toRemoveFromMap.forEach(x=>this._mapping.delete(x));
        this._destination.update(...temp);
    }
    public release(){
        this._source.removeChangeListenner(this._delegatedChangeListenner);
    }

}